// Multi-role helpers. `user.role` is the primary (broadest) role; `user.roles` lists all.
export const userRoles = (user) => (user?.roles?.length ? user.roles : user?.role ? [user.role] : []);

export const hasRole = (user, ...roles) => userRoles(user).some((r) => roles.includes(r));

const RESTRICTED = ["hr_clerk", "appraiser"];
const SCOPED_PAGES = { hr_clerk: ["/employees", "/employee-approvals", "/departments", "/documents", "/chat", "/ai"], appraiser: ["/performance", "/tasks", "/chat", "/ai"] };

// HR Clerk / Appraiser with no broader role: limited to their own pages, never pay data.
export const isRestricted = (user) => {
    const held = userRoles(user);
    return held.some((r) => RESTRICTED.includes(r)) && held.every((r) => RESTRICTED.includes(r) || r === "employee");
};

export const scopedPages = (user) => [...new Set(userRoles(user).flatMap((r) => SCOPED_PAGES[r] || []))];


export const isFinanceLead = (user) =>
    hasRole(user, "finance_lead") ||
    (hasRole(user, "department_lead") && (user?.department || "").trim().toLowerCase() === "finance");

export const ROLE_LABELS = {
    admin: "Admin",
    hr: "HR",
    department_lead: "Dept Lead",
    accountant: "Accountant",
    finance_lead: "Finance Lead",
    viewer: "Viewer",
    hr_clerk: "HR Clerk",
    appraiser: "Appraiser",
    employee: "Employee",
    super_admin: "Super Admin",
};
